export default {
  name: 'transaction_customer_address_line1',
  component_path: 'modules/procedures/blocks/BlockInputText',
  static_options: {
    autocomplete: 'shipping address-line1'
  }
}